import {
  kitPartCss,
  panel,
  panelAction,
  panelActionCss,
  panelCss,
  rowList,
  rowsCss,
} from '../armKit';
import { searchPath } from '../destinations';
import { fieldFeedWorks } from '../pageData';
import { topInterest } from '../profileFacts';

import type { ArmContext, ArmSpec } from '../armRegistry';
import type { Row } from '../armKit';
import type { FeedPaper } from '../pageData';

const ROWS = 5;
const SUBTITLE = 'Recent papers tagged with your top research interest.';
const PAPER_SOURCE = 'profile-liautotest-field-paper';
const SEARCH_SOURCE = 'profile-liautotest-field-search';

function armCss(scope: string): string {
  return (
    panelCss(scope, { marginBottom: '0' }) +
    rowsCss(scope) +
    kitPartCss('rowTitle', scope, 'font-weight: 500;') +
    panelActionCss(scope)
  );
}

function rowsFor(papers: FeedPaper[], ctx: ArmContext): Row[] {
  return papers.map((paper) => ({
    title: paper.title,
    url: paper.url,
    onClick: () => ctx.track(PAPER_SOURCE, { entityId: paper.id }),
  }));
}

export const fieldFeedFirstScreen: ArmSpec = {
  onReady: async (ctx) => {
    const topic = topInterest();
    if (topic == null) return;

    // Awaited before the slot is mounted, so a feed that never arrives leaves no
    // empty container behind and the page reads as control.
    const feed = await fieldFeedWorks(topic.id);
    const papers = feed
      .filter((paper) => !paper.authorIds.includes(ctx.viewedUserId))
      .slice(0, ROWS);
    if (papers.length === 0) return;

    const slot = ctx.mountSlot('columnTop');
    if (slot == null) return;

    ctx.injectStyles(armCss(ctx.scope));

    const { root, body } = panel({
      title: `New in ${topic.name}`,
      subtitle: SUBTITLE,
    });
    body.appendChild(rowList(rowsFor(papers, ctx)));
    body.appendChild(
      panelAction(`Search ${topic.name}`, searchPath(topic.name), () =>
        ctx.track(SEARCH_SOURCE, { entityId: topic.id }),
      ),
    );
    slot.appendChild(root);
  },
};
